module.exports = __webpack_public_path__ + "img/BITCOIN_CASH.1b484474.svg";